import { companyName } from 'core/transformers';
import companyType from './companyType';

const title = (expose: any) =>
  `${companyName(expose)} - ${companyType(expose.cwid)} bei ImmoScout24`;

export default title;
